import React from 'react';

// Styles
import { StyledAccordionContainer } from './plansummary.styled';

// UI Components
import AccordionPanel from '../../../components/common/app-components/AccordionPanel';

// Local Components
import PlanSummaryTemplate from './PlanSummaryTemplate';
import { ConditionalRendering } from '../../../components/common/conditional-rendering';
import { FormattedMessage } from 'react-intl';
import { IAccordionHeaderProps, IPlanSummaryAccordionProps } from './planSummary.types';
import usePlanSummary from './hooks/usePlanSummary';

const AccordionHeader = ({ planType }: IAccordionHeaderProps) => {
    return (
        <p className={'bold-header'} data-testid={`accordion-header-${planType.toLowerCase()}`}>
            <FormattedMessage id={`plansummary.${planType.toLowerCase()}`} />
        </p>
    );
};

export default function PlanSummaryAccordion({ planList, planType, allowDisenrollCTA }: IPlanSummaryAccordionProps) {
    const { hasAccordionPanelFixedPadding } = usePlanSummary();
    return (
        <ConditionalRendering isTrue={planList?.length > 0}>
            <StyledAccordionContainer
                hasAccordionPanelFixedPadding={hasAccordionPanelFixedPadding}
                data-testid={`${planType.toLowerCase()}-plan-accordion-container`}
            >
                <AccordionPanel
                    id="planAccordian"
                    isExpandable={true}
                    header={<AccordionHeader planType={planType} />}
                    isInitialExpanded={true}
                    data-testid="accordion-panel-enrolled"
                >
                    {planList?.map(plan => (
                        <PlanSummaryTemplate key={plan.planId} plan={plan} allowDisenrollCTA={allowDisenrollCTA} />
                    ))}
                </AccordionPanel>
            </StyledAccordionContainer>
        </ConditionalRendering>
    );
}
